import { Divider } from '@eventbrite/eds-divider';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import React from 'react';
import { SearchPaginator } from '../SearchPaginator';

interface SearchFooterLegacyProps {
    handleGetPage: Function;
    currentPage: number;
    isNextDisabled?: boolean;
    firstPageUrl?: string;
    lastPageUrl?: string;
    pageCount: number;
    hasEventResults?: boolean;
    trendingSearchData?: object;
    history?: object;
    nextPageUrl?: string;
    prevPageUrl?: string;
}

export class SearchFooterLegacy extends React.PureComponent<
    SearchFooterLegacyProps
> {
    _onGetPage = (pageNumber: number) => {
        const { handleGetPage, history } = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }

        handleGetPage(pageNumber, history);
    };

    render() {
        const {
            currentPage,
            isNextDisabled,
            nextPageUrl,
            prevPageUrl,
            firstPageUrl,
            pageCount,
            lastPageUrl,
            hasEventResults,
        } = this.props;

        let searchFooter = null;

        if (hasEventResults) {
            searchFooter = (
                <div>
                    <div className="destination-search-footer eds-l-mar-bot-10 eds-l-mar-top-10 eds-l-mar-left-3">
                        <SearchPaginator
                            currentPage={currentPage}
                            handleGetPage={this._onGetPage}
                            isNextDisabled={isNextDisabled}
                            nextUrl={nextPageUrl}
                            prevUrl={prevPageUrl}
                            firstPageUrl={firstPageUrl}
                            lastPageUrl={lastPageUrl}
                            pageCount={pageCount}
                        />
                    </div>
                    <div className="eds-l-pad-hor-3">
                        <Divider color="grey-300" />
                    </div>
                </div>
            );
        }

        return <footer className="search-footer">{searchFooter}</footer>;
    }
}
